<template>
    <div class="flex flex-col flex-grow bg-gray-800 pt-5 pb-4 w-full sticky top-0 h-screen">
        <div class="flex items-center flex-shrink-0 px-4">
            <inertia-link :href="route('dashboard')" class="w-full">
                <img alt="Storemanager" class="h-auto w-full" src="../../../assets/images/Logo_AIW_dark.svg">
            </inertia-link>
        </div>
        <navigation-user-bar class="hidden lg:block"/>
        <div class="mt-5 flex-1 flex flex-col overflow-y-auto">
            <div>
                <nav class="px-2 flex flex-col space-y-1">
                    <navigation-link
                        :href="route('dashboard')"
                        :is-active="route().current('dashboard')"
                        icon="home"
                    >
                        {{ $t('general.dashboard') }}
                    </navigation-link>

                    <template
                        v-if="auth.can('store.profitAndLoss') || (auth.user.stores.length > 0 && auth.canAny(auth.user.stores.map(store => ({action: 'store.profitAndLoss', model: store}))))"
                    >
                        <navigation-link
                            :href="route('stores.profit-and-loss.select')"
                            :is-active="route().current('stores.profit-and-loss.*')"
                            icon="currency-euro"
                            icon-bg-from="from-orange-500"
                            icon-bg-to="to-red-500"
                        >
                            {{ $t('general.profit_and_loss') }}
                        </navigation-link>
                    </template>

                    <template
                        v-if="auth.can('store.profitAndLoss') || (auth.user.stores.length > 0 && auth.canAny(auth.user.stores.map(store => ({action: 'store.profitAndLoss', model: store}))))"
                    >
                        <navigation-link
                            :href="route('stores.budgets.select')"
                            :is-active="route().current('stores.budgets.*')"
                            icon="cash"
                            icon-bg-from="from-yellow-500"
                            icon-bg-to="to-orange-500"
                        >
                            {{ $t('general.budget') }}
                        </navigation-link>

                        <navigation-link
                            :href="route('stores.budget-projections.select')"
                            :is-active="route().current('stores.budget-projections.*')"
                            icon="cash"
                            icon-bg-from="from-yellow-500"
                            icon-bg-to="to-orange-500"
                        >
                            {{ $t('general.budget-projection') }}
                        </navigation-link>
                    </template>

                    <template v-if="auth.can('evaluation.viewAny')">
                        <navigation-link
                            :href="route('evaluations.index')"
                            :is-active="route().current('evaluations.*')"
                            icon="collection"
                            icon-bg-from="from-fuchsia-500"
                            icon-bg-to="to-violet-500"
                        >
                            {{ $t('general.evaluations') }}
                        </navigation-link>
                    </template>

                    <template v-if="auth.can('review.viewAny')">
                        <navigation-link
                            :href="route('reviews.index')"
                            :is-active="route().current('reviews.*')"
                            icon="annotation"
                            icon-bg-from="from-amber-500"
                            icon-bg-to="to-red-500"
                        >
                            {{ $t('general.reviews') }}
                        </navigation-link>
                    </template>
                </nav>
            </div>

            <template v-if="auth.canAny(['company.viewAny', 'store.viewAny', 'user.viewAny', 'import.viewAny'])">
                <hr class="h-px my-6 bg-gray-700 border-none">

                <div>
                    <nav class="px-2 flex flex-col space-y-1">
                        <navigation-link
                            v-if="auth.can('company.viewAny')" :href="route('companies.index')"
                            :is-active="route().current('companies.*')"
                            icon="office-building" icon-bg-from="from-green-500"
                            icon-bg-to="to-teal-500"
                        >
                            {{ $t('general.companies') }}
                        </navigation-link>

                        <navigation-link
                            v-if="auth.can('store.viewAny')" :href="route('stores.index')"
                            :is-active="route().current('stores.*') && !route().current('stores.budgets.*') && !route().current('stores.profit-and-loss.*') && !route().current('stores.budget-projections.*')"
                            icon="shopping-cart"
                            icon-bg-from="from-teal-500"
                            icon-bg-to="to-sky-500"
                        >
                            {{ $t('general.stores') }}
                        </navigation-link>

                        <navigation-link
                            v-if="auth.can('user.viewAny')" :href="route('users.index')"
                            :is-active="route().current('users.*')"
                            icon="users"
                            icon-bg-from="from-sky-500"
                            icon-bg-to="to-indigo-500"
                        >
                            {{ $t('general.users') }}
                        </navigation-link>

                        <navigation-link
                            v-if="auth.can('import.viewAny')" :href="route('imports.index')"
                            :is-active="route().current('imports.*')"
                            icon="download"
                            icon-bg-from="from-indigo-500"
                            icon-bg-to="to-purple-500"
                        >
                            {{ $t('general.imports') }}
                        </navigation-link>
                    </nav>
                </div>
            </template>
        </div>

        <developer-panel class="px-3 mb-4"/>

        <div class="px-3 flex items-center justify-between">
            <locale-toggle/>
            <dark-mode-toggle/>
        </div>
    </div>
</template>

<script>
import NavigationLink from './NavigationLink';
import NavigationUserBar from './NavigationUserBar';
import LocaleToggle from '../Base/LocaleToggle';
import DarkModeToggle from '../Base/DarkModeToggle';
import DeveloperPanel from '@/Components/DeveloperPanel';

export default {
    name: 'Navigation',

    components: {
        DarkModeToggle,
        DeveloperPanel,
        LocaleToggle,
        NavigationUserBar,
        NavigationLink,
    },
};
</script>
